import { render, staticRenderFns } from "./DistributionPointPickerDialog.vue?vue&type=template&id=224b480c"
import script from "./DistributionPointPickerDialog.vue?vue&type=script&lang=js"
export * from "./DistributionPointPickerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports